import React from 'react';
import { Form, Button } from 'react-bootstrap';
import { getDefaultDashboardDateRange } from '../../utils/requirementDateFilter';

function RequirementDateRangeFilter({
  fromDate,
  toDate,
  onFromChange,
  onToChange,
  label = '',
  inline = true,
  className = '',
  defaultFromDate = getDefaultDashboardDateRange().from,
  defaultToDate = getDefaultDashboardDateRange().to,
  clearLabel = 'Reset',
  onClear,
  hideClearButton = false,
  forceShowClear = false,
}) {
  const hasCustomValue = fromDate !== defaultFromDate || toDate !== defaultToDate;
  const showClear = !hideClearButton && (hasCustomValue || forceShowClear);

  const handleClear = () => {
    if (onClear) {
      onClear();
      return;
    }
    onFromChange(defaultFromDate);
    onToChange(defaultToDate);
  };

  const content = (
    <>
      {label ? <span className="hr-date-range-label">{label}</span> : null}
      <div className="hr-date-range-fields">
        <Form.Control
          type="date"
          className="hr-date-input"
          value={fromDate || ''}
          onChange={(event) => onFromChange(event.target.value)}
          aria-label="From date"
          title="From date"
        />
        <span className="hr-date-range-sep">to</span>
        <Form.Control
          type="date"
          className="hr-date-input"
          value={toDate || ''}
          onChange={(event) => onToChange(event.target.value)}
          aria-label="To date"
          title="To date"
        />
        {showClear ? (
          <Button
            variant="outline-secondary"
            size="sm"
            className="hr-date-range-clear"
            onClick={handleClear}
            type="button"
          >
            {clearLabel}
          </Button>
        ) : null}
      </div>
    </>
  );

  if (inline) {
    return (
      <div className={`hr-date-range-inline ${className}`.trim()}>
        {content}
      </div>
    );
  }

  return (
    <div className={`hr-date-range-block mb-3 ${className}`.trim()}>
      {content}
    </div>
  );
}

export default RequirementDateRangeFilter;
